import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import RequireAuth from './RequireAuth';
import SignIn from './SignIn';
import SignUp from './SignUp';
import Home from './Home';
import MarkdownList from './MarkdownList';
import MarkdownEditor from './MarkdownEditor';
import MarkdownSelectList from './MarkdownSelectList';
import MarkdownDetail from './MarkdownDetail';
import UserList from './UserList';
import TaskList from './TaskList';
import TaskDetail from './TaskDetail';
import PaperTheater from './PaperTheater';
import GroupList from './GroupList';
import GroupSelectList from './GroupSelectList';
import UserTaskDashboard from './UserTaskDashboard';
import UserSelectList from './UserSelectList';

const App: React.FC = () => {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/signin" element={<SignIn />} />
          <Route path="/signup" element={<SignUp />} />

          <Route path="/" element={
            <RequireAuth>
              <Home />
            </RequireAuth>
          }>
            <Route index element={<div>ホーム画面です</div>} />
            <Route path="admin/list" element={<MarkdownList />} />
            <Route path="admin/new" element={<MarkdownEditor />} />
            <Route path="admin/edit/:id" element={<MarkdownEditor />} />
            <Route path="detail/:id" element={<MarkdownDetail />} />
            <Route path="admin/users" element={<UserList />} />
            <Route path="admin/groups" element={<GroupList />} />
            <Route path="/tasklist" element={<TaskList />} />
            <Route path="/task/:id" element={<TaskDetail />} />
            <Route path="/help/papertheater" element={<PaperTheater />} />
            <Route path="/select" element={<GroupSelectList />} />
            <Route path="/select/:groupId" element={<MarkdownSelectList />} />
            <Route path="/user-select" element={<UserSelectList />} />
            <Route path="/user-tasks/:userId" element={<UserTaskDashboard />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App;
